<template>
  <div>
    <div
      class="z-title z-title--small spacer-bottom-l"
      v-if="ready"
    >
      {{ titleOnReady }}
    </div>

    <div
      class="z-title z-title--small spacer-bottom-l"
      v-else
    >
      {{ title }}
    </div>

    <slot></slot>

    <div v-if="!hasError">
      <template v-if="ready">
        <pix-card :callback-clipboard="copySuccess" :qr-code="qrCode" :expiration-at="expirationAt" />
      </template>

      <button
        class="z-button z-button--secondary z-button--block spacer-bottom-m js-create-pix-btn"
        v-else-if="unavailable"
        @click="handleGeneratePix()"
      >
        Gerar pix
      </button>

      <button
        class="z-button z-button--secondary z-button--block spacer-bottom-m"
        v-else-if="waiting"
        disabled
      >
        <z-loading variant="dotsSpinner" size="medium" />
        Gerando pix
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.payment-code {
  color: var(--color-neutral-black);
  font-size: rem(16);
  line-height: rem(24);
  margin-bottom: var(--space-extra-large);
}
</style>

<script>
import pixCard from './pix-card.vue';

const stringPropType = { type: String, required: true };
const booleanPropType = { type: Boolean, required: true };
const functionPropType = { type: Function, required: true };

export default {
  components: { pixCard },
  props: {
    payment: {
      required: true,
      validator: (payment) => typeof payment === 'object' || payment === null,
    },
    title: stringPropType,
    titleOnReady: stringPropType,
    ready: booleanPropType,
    waiting: booleanPropType,
    unavailable: booleanPropType,
    callbackClipboard: functionPropType,
    handleGeneratePix: functionPropType,
    hasError: booleanPropType,
    from: stringPropType,
  },
  computed: {
    qrCode() {
      return this.payment.metadata.qr_code;
    },
    expirationAt() {
      switch (this.from) {
        case 'paymentPromise':
          return this.payment.due_date;
        case 'billPayment':
          return this.payment.expiry_date;
        default:
          return null;
      }
    },
  },
  methods: {
    copySuccess() {
      this.$toast.show('success', 'Código copiado', 4000);
      this.callbackClipboard();
    },
  },
};
</script>
